export class Money {
  constructor(
    public amount?: number, public currency?: string) {
  }
}
